export function OutlineAjsuteDeCostosIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5158 7.49743C11.055 7.19503 10.071 6.65264 8.76544 6.66224C8.21825 6.66224 6.87905 6.67663 6.34625 7.49743C6.05825 7.93903 5.99585 8.63983 6.34625 9.16303C7.27265 10.5358 10.2582 9.46062 11.1798 10.8286C11.5302 11.347 11.4678 12.0526 11.1798 12.4942C10.6662 13.2862 9.39904 13.315 8.84224 13.3294C7.50785 13.3582 6.49025 12.8062 6.01025 12.4942"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path d="M8.76538 5.00195V6.66755" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M8.76538 13.334V14.9996" stroke={stroke} strokeWidth={strokeWidth} />
      <path
        d="M21.0146 6.99838V4.99679C21.0146 3.8928 20.117 3 19.0178 3H5.01144C3.90744 3 3.01465 3.8928 3.01465 4.99679V19.0031C3.01465 20.1071 3.90744 20.9999 5.01144 20.9999H7.01783"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8909 14.2258L17.4268 11.7617L12.4985 16.69L14.9626 19.1541L19.8909 14.2258Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5053 11.1422C21.1841 11.821 21.1841 12.9275 20.5053 13.6063L19.8909 14.2207L17.4268 11.7565L18.0411 11.1422C18.72 10.4634 19.8264 10.4634 20.5053 11.1422Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7286 20.3854L10.6519 20.9998L11.2663 17.9182L12.4998 16.6895L14.9622 19.1518L13.7286 20.3854Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
